import { makeStyles } from "tss-react/mui";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ArrowButton from "components/CustomButtons/ArrowButton";

import TextList from "../TextList/TextList";

const useStyles = makeStyles()((theme) => ({
  newerModelLabel: {
    lineHeight: "1rem", //'0.75rem',
    alignItems: "center",
    fontSize: "12px",
    display: "flex",
  },
  singleLine: { marginRight: theme.spacing(1) },
  marginTop: {
    marginTop: theme.spacing(2),
  },
  justifyCenter: { justifyContent: "center" },
}));

const TextAlertHeading = (props) => {
  const { classes, cx } = useStyles();
  const { singleLine, heading, center, marginTop, noIcon } = props;
  return (
    <div
      className={cx({
        [classes.newerModelLabel]: true,
        [classes.marginTop]: marginTop,
        [classes.singleLine]: singleLine,
        [classes.justifyCenter]: center,
      })}
    >
      {!noIcon && (
        <ErrorOutlineIcon
          fontSize="small"
          color="primary"
          sx={{ mb: 0.25, mr: 0.5, fontSize: "0.9rem" }}
        />
      )}
      {heading}
    </div>
  );
};

const TextAlertLink = ({ href, targetTitle, prefetch = true }) => {
  return (
    <ArrowButton href={href} prefetch={prefetch} text={targetTitle} hideArrow />
  );
};

export const TextAlert = ({
  links,
  heading,
  singleLine,
  center,
  noIcon,
  gridSizes = {},
}) => {
  return (
    <>
      <TextAlertHeading
        noIcon={noIcon}
        singleLine={singleLine}
        heading={heading}
        center={center}
      />
      <TextList
        center={center}
        sx={{ fontSize: "0.75rem" }}
        listItems={links?.map((link) => ({
          id: `${heading}-${link.href}`,
          content: (
            <TextAlertLink
              href={link.href}
              targetTitle={link.targetTitle}
              prefetch={link.prefetch}
            />
          ),
        }))}
      />
    </>
  );
};
